import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";

import Home from "./pages/Home";
import AllProducts from "./pages/AllProducts";
import Bundles from "./pages/Bundles";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Disclaimer from "./pages/Disclaimer";
import TrackOrder from "./pages/TrackOrder";

function App() {
    return (
        <div className="App">
            <CartProvider>
                <BrowserRouter>
                    <Navbar />
                    <CartDrawer />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/all" element={<AllProducts />} />
                        <Route path="/bundles" element={<Bundles />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/checkout" element={<Checkout />} />
                        <Route path="/order/:orderNumber" element={<OrderSuccess />} />
                        <Route path="/admin-login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/disclaimer" element={<Disclaimer />} />
                        <Route path="/track" element={<TrackOrder />} />
                    </Routes>
                    <Footer />
                    <Toaster position="bottom-right" richColors />
                </BrowserRouter>
            </CartProvider>
        </div>
    );
}

export default App;
